<style scoped>

</style>

<template>
  <span v-if="!simple">
    <slot name="list"></slot>
  </span>
  <mu-menu cover v-else>
    <mu-button small icon>
      <mu-icon :value="icon"></mu-icon>
    </mu-button>
    <mu-list slot="content">
      <slot name="list"></slot>
    </mu-list>
  </mu-menu>
</template>

<script>
export default {
  name: 'ButtonOrListGroup',
  props: {
    simple: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: "more_vert"
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}

</script>
